export enum DialogTypeEnum {
  FORM = "FORM",
  DELETE = "DELETE",
  INFO = "INFO",
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
  ERROR = "ERROR",
}
